import { ADD_ON_CARD, MERCH_CARD, PRODUCT_PAGE_FEATURE_TABLE_HEADER, STARTER_CUSTOMER_PLATFORM_UPSELL_MERCH_CARD, SUITE_CARD, TRACKING_SOURCES } from '../../v2/constants/tracking/TrackingSources';
import { isTrackingSource } from './typeguards';

/**
 * Tracking data patterns for generating consistent uniqueId and source values
 */
export const TRACKING_PATTERNS = {
  MERCH_CARD: apiName => `${MERCH_CARD}-${apiName}`,
  STARTER_CUSTOMER_PLATFORM_UPSELL_MERCH_CARD: apiName => `${STARTER_CUSTOMER_PLATFORM_UPSELL_MERCH_CARD}-${apiName}`,
  FEATURE_TABLE_HEADER: apiName => `${PRODUCT_PAGE_FEATURE_TABLE_HEADER}-${apiName}`,
  ADD_ON_CARD: apiName => `${ADD_ON_CARD}-${apiName}`,
  SUITE_CARD: productLevel => `${SUITE_CARD}-${productLevel.toLowerCase()}`
};

/**
 * Creates consistent TrackingData for merch cards
 */
export const createMerchCardTrackingData = (apiName, screen) => ({
  app: 'pricing-pages',
  screen,
  uniqueId: TRACKING_PATTERNS.MERCH_CARD(apiName),
  source: TRACKING_PATTERNS.MERCH_CARD(apiName)
});

/**
 * Creates consistent TrackingData for upsell merch cards
 */
export const createUpsellMerchCardTrackingData = (apiName, screen) => ({
  app: 'pricing-pages',
  screen,
  uniqueId: TRACKING_PATTERNS.STARTER_CUSTOMER_PLATFORM_UPSELL_MERCH_CARD(apiName),
  source: TRACKING_PATTERNS.STARTER_CUSTOMER_PLATFORM_UPSELL_MERCH_CARD(apiName)
});

/**
 * Creates consistent TrackingData for feature table headers
 */
export const createFeatureTableHeaderTrackingData = (apiName, screen) => ({
  app: 'pricing-pages',
  screen,
  uniqueId: TRACKING_PATTERNS.FEATURE_TABLE_HEADER(apiName),
  source: TRACKING_PATTERNS.FEATURE_TABLE_HEADER(apiName)
});

/**
 * Creates consistent TrackingData for add-on cards
 */
export const createAddOnCardTrackingData = apiName => ({
  app: 'pricing-pages',
  screen: 'add-ons',
  uniqueId: TRACKING_PATTERNS.ADD_ON_CARD(apiName),
  source: TRACKING_PATTERNS.ADD_ON_CARD(apiName)
});

/**
 * Creates consistent TrackingData for suite cards
 * @param productLevel - Suite product level (e.g., "STARTER", "PROFESSIONAL", "ENTERPRISE")
 * @param screen - Screen context for the suite card
 */
export const createSuiteCardTrackingData = (productLevel, screen) => ({
  app: 'pricing-pages',
  screen,
  uniqueId: TRACKING_PATTERNS.SUITE_CARD(productLevel),
  source: TRACKING_PATTERNS.SUITE_CARD(productLevel)
});
export const getTrackingSourceFromTrackingData = trackingData => {
  const possibleSources = Object.values(TRACKING_SOURCES);

  // parse the string to find any one of these at the start TrackingSources
  const trackingSource = possibleSources.sort((a, b) => b.length - a.length).find(source => {
    var _ref;
    return (_ref = trackingData.source || trackingData.uniqueId) === null || _ref === void 0 ? void 0 : _ref.startsWith(source);
  });
  if (!isTrackingSource(trackingSource)) {
    return null;
  }
  return trackingSource;
};